import { globalSocialLinks } from '../data/divisions';

export function Footer(): string {
  const socialIconsHtml = globalSocialLinks.map(link => /*html*/`
    <a 
      href="${link.url}" 
      target="_blank" 
      rel="noopener noreferrer"
      title="${link.name}"
      style="width: 40px; height: 40px; border-radius: 10px; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1); display: inline-flex; align-items: center; justify-content: center; color: #cbd5e1; transition: all 0.2s ease;"
      onmouseover="this.style.color='#00f2fe'; this.style.borderColor='rgba(0,242,254,0.4)'; this.style.transform='translateY(-2px)'"
      onmouseout="this.style.color='#cbd5e1'; this.style.borderColor='rgba(255,255,255,0.1)'; this.style.transform='translateY(0)'"
    >
      <sl-icon name="${link.icon}" style="font-size: 1.25rem;"></sl-icon>
    </a>
  `).join('');

  return /*html*/`
    <footer style="background: #05060a; border-top: 1px solid rgba(255, 255, 255, 0.08); padding: 4.5rem 0 2.5rem; margin-top: auto;">
      <div class="container">
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 2.5rem; margin-bottom: 3.5rem;">
          
          <!-- Column 1: Studio Brand -->
          <div>
            <div style="display: flex; align-items: center; gap: 0.6rem; margin-bottom: 1rem;">
              <div style="width: 32px; height: 32px; border-radius: 8px; background: linear-gradient(135deg, #00f2fe 0%, #a855f7 100%); display: flex; align-items: center; justify-content: center; font-weight: 900; font-size: 1.1rem; color: #07080d;">
                M
              </div>
              <span style="font-size: 1.25rem; font-weight: 800; color: #fff;">ATOMIX<span style="color: #00f2fe;">M</span></span>
            </div>
            <p style="color: #94a3b8; font-size: 0.9rem; line-height: 1.6; margin-bottom: 1.25rem;">
              AtomixM (Multimedia & Mass) is an independent creative and deep-tech powerhouse pioneering open-source game engines, generative AI music, cinematic short films, and vibe coding architecture.
            </p>
            <div style="display: flex; gap: 0.6rem; flex-wrap: wrap;">
              ${socialIconsHtml}
            </div>
          </div>

          <!-- Column 2: Divisions -->
          <div>
            <h4 style="color: #ffffff; font-size: 1rem; margin-bottom: 1.2rem; text-transform: uppercase; letter-spacing: 0.08em;">Works &amp; Interests</h4>
            <ul style="list-style: none; display: flex; flex-direction: column; gap: 0.65rem; padding: 0;">
              <li>
                <a href="#games" style="color: #94a3b8; font-size: 0.9rem; display: flex; align-items: center; gap: 0.5rem;">
                  <span style="color: #06d6a0;">●</span> AtomixGame (Engines & Steam)
                </a>
              </li>
              <li>
                <a href="#musics" style="color: #94a3b8; font-size: 0.9rem; display: flex; align-items: center; gap: 0.5rem;">
                  <span style="color: #a855f7;">●</span> AtomixMusics (AI Music & Audio)
                </a>
              </li>
              <li>
                <a href="#films" style="color: #94a3b8; font-size: 0.9rem; display: flex; align-items: center; gap: 0.5rem;">
                  <span style="color: #f97316;">●</span> AtomixFilms (AI Cinema & Shorts)
                </a>
              </li>
              <li>
                <a href="#devs" style="color: #94a3b8; font-size: 0.9rem; display: flex; align-items: center; gap: 0.5rem;">
                  <span style="color: #00d2ff;">●</span> AtomixDevs (Vibe Coding Blog)
                </a>
              </li>
            </ul>
          </div>

          <!-- Column 3: Ecosystem & Repos -->
          <div>
            <h4 style="color: #ffffff; font-size: 1rem; margin-bottom: 1.2rem; text-transform: uppercase; letter-spacing: 0.08em;">Ecosystem</h4>
            <ul style="list-style: none; display: flex; flex-direction: column; gap: 0.65rem; padding: 0;">
              <li>
                <a href="https://github.com/atomixgame" target="_blank" rel="noopener noreferrer" style="color: #94a3b8; font-size: 0.9rem;">
                  GitHub Organization: @atomixgame
                </a>
              </li>
              <li>
                <a href="https://atomixnmc.github.io/mydevblog/" target="_blank" rel="noopener noreferrer" style="color: #94a3b8; font-size: 0.9rem;">
                  Dev Blog: atomixnmc.github.io/mydevblog/
                </a>
              </li>
              <li>
                <a href="https://youtube.com/@atomixchannel" target="_blank" rel="noopener noreferrer" style="color: #94a3b8; font-size: 0.9rem;">
                  YouTube Channel: @atomixchannel
                </a>
              </li>
              <li>
                <a href="https://tiktok.com/@atomixchannel" target="_blank" rel="noopener noreferrer" style="color: #94a3b8; font-size: 0.9rem;">
                  TikTok: @atomixchannel
                </a>
              </li>
            </ul>
          </div>

          <!-- Column 4: Founder & Community -->
          <div>
            <h4 style="color: #ffffff; font-size: 1rem; margin-bottom: 1.2rem; text-transform: uppercase; letter-spacing: 0.08em;">Founder & Events</h4>
            <p style="color: #94a3b8; font-size: 0.9rem; line-height: 1.6; margin-bottom: 0.75rem;">
              Founded by <strong>Cuong Nguyen Manh</strong> (atomixnmc). Exhibitor & creator at Atlanta Comic Cons & Game Summits (2024, 2026).
            </p>
            <a href="#about" class="btn-ghost" style="padding: 0.4rem 0.8rem; font-size: 0.82rem; border-radius: 6px;">
              Read Founder Story →
            </a>
          </div>

        </div>

        <!-- Copyright bar -->
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem; padding-top: 2rem; border-top: 1px solid rgba(255, 255, 255, 0.06); color: #64748b; font-size: 0.85rem;">
          <p>&copy; ${new Date().getFullYear()} AtomixM Studio (Mass & Multimedia). All rights reserved.</p>
          <div style="display: flex; gap: 1.5rem;">
            <a href="#home" style="color: #64748b;">Home</a>
            <a href="#about" style="color: #64748b;">About</a>
            <a href="#contact" style="color: #64748b;">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  `;
}
